import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, vModelText as _vModelText, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = {
  class: "ui menu no-print",
  id: "main-menu"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "icon bars" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "home icon" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "info icon" }, null, -1)
const _hoisted_6 = { class: "fat-only" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "map icon" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "users icon" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "object group outline icon" }, null, -1)
const _hoisted_10 = { class: "fat-only" }
const _hoisted_11 = { class: "right menu" }
const _hoisted_12 = { class: "ui simple dropdown item" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "globe icon" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "fat-only" }, "語言 Language", -1)
const _hoisted_15 = { class: "menu" }
const _hoisted_16 = { class: "bell icon" }
const _hoisted_17 = {
  key: 0,
  class: "ui red small label"
}
const _hoisted_18 = { class: "ui simple dropdown item" }
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 1,
  class: "user icon"
}
const _hoisted_21 = { class: "menu" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "flag icon" }, null, -1)
const _hoisted_23 = { class: "ui divider" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "book icon no-float" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "sign-out icon" }, null, -1)
const _hoisted_26 = ["href", "title"]
const _hoisted_27 = ["href"]
const _hoisted_28 = { key: 2 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "home icon no-float" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "info icon no-float" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "save icon no-float" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "users icon no-float" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "map icon no-float" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "object group outline icon no-float" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "user icon no-float" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "book icon no-float" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "comments icon no-float" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "globe icon no-float" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "github icon no-float" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "save icon no-float" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", { class: "no-print" }, null, -1)
const _hoisted_42 = {
  key: 1,
  class: "ui form container no-print"
}
const _hoisted_43 = { class: "search-input" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("br", { class: "no-print" }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("br", { class: "no-print" }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("br", { class: "no-print" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Tutorial = _resolveComponent("Tutorial")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_chatbox = _resolveComponent("chatbox")!
  const _component_login = _resolveComponent("login")!
  const _directive_autofocus = _resolveDirective("autofocus")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("button", {
        class: "no-border ui item",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
      }, _hoisted_3),
      _createVNode(_component_router_link, {
        class: "item fat-only",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('login.hp')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: _normalizeClass(["item", {'fat-only': _ctx.uid}]),
        to: "/about"
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('login.ab')), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        class: _normalizeClass(["item", {'fat-only': _ctx.uid}]),
        to: "/maps"
      }, {
        default: _withCtx(() => [
          _hoisted_7,
          _createTextVNode(_toDisplayString(_ctx.$t('login.mp')), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        class: _normalizeClass(["item", {'fat-only': !_ctx.uid}]),
        to: "/friends"
      }, {
        default: _withCtx(() => [
          _hoisted_8,
          _createTextVNode(_toDisplayString(_ctx.$t('login.fr')), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        class: _normalizeClass(["item", {'fat-only': !_ctx.uid}]),
        to: "/groups"
      }, {
        default: _withCtx(() => [
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('login.gp')), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              class: "no-border ui item",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeZh && _ctx.changeZh(...args)))
            }, "中文 Chinese"),
            _createElementVNode("button", {
              class: "no-border ui item",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeEn && _ctx.changeEn(...args)))
            }, "英文 English")
          ])
        ]),
        _withDirectives(_createElementVNode("button", {
          class: "ui item no-border",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToNotifications && _ctx.goToNotifications(...args)))
        }, [
          _createElementVNode("i", _hoisted_16, [
            (_ctx.unreadCount > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.unreadCount), 1))
              : _createCommentVNode("", true)
          ])
        ], 512), [
          [_vShow, _ctx.uid]
        ]),
        _createElementVNode("div", _hoisted_18, [
          (_ctx.photoURL)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "ui avatar image",
                src: _ctx.photoURL,
                alt: "User Avatar",
                onError: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.useDefaultAvatar && _ctx.useDefaultAvatar(...args))),
                onLoad: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onImageLoad && _ctx.onImageLoad(...args)))
              }, null, 40, _hoisted_19))
            : (_openBlock(), _createElementBlock("i", _hoisted_20)),
          _createElementVNode("div", _hoisted_21, [
            (_ctx.uid)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "item",
                  to: "/profile"
                }, {
                  default: _withCtx(() => [
                    _hoisted_22,
                    _createTextVNode(_toDisplayString(_ctx.$t('login.fg')), 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "no-border item",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleLogin && _ctx.toggleLogin(...args)))
                }, _toDisplayString(_ctx.$t('login.login' )), 1)),
            _withDirectives(_createElementVNode("div", _hoisted_23, null, 512), [
              [_vShow, _ctx.myGroupIdx().length > 0]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myGroupIdx(), (i) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                class: "item",
                key: i,
                to: '/group/' + i
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.groups[i].n), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128)),
            (_ctx.uid)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  class: "item",
                  to: "/book"
                }, {
                  default: _withCtx(() => [
                    _hoisted_24,
                    _createTextVNode(_toDisplayString(_ctx.$t('login.bk')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.uid)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  class: "no-border ui item",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                }, [
                  _hoisted_25,
                  _createTextVNode(_toDisplayString(_ctx.$t('login.logout')), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "no-print news-carousel",
      onMouseenter: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.pauseNewsRotation && _ctx.pauseNewsRotation(...args))),
      onMouseleave: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.startNewsRotation && _ctx.startNewsRotation(...args)))
    }, [
      _createVNode(_Transition, {
        name: "news-fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_ctx.currentNews)
            ? (_openBlock(), _createElementBlock("div", {
                class: "news-slide",
                key: _ctx.newsSlideKey(_ctx.currentNews)
              }, [
                (_ctx.currentNews.type === 'api')
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _ctx.currentNews.url,
                      title: _ctx.currentNews.description,
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, _toDisplayString(_ctx.formatApiNews(_ctx.currentNews)), 9, _hoisted_26))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.currentNews.h)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: _ctx.currentNews.h,
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }, _toDisplayString(_ctx.$t('news.' + _ctx.currentNews.t)), 9, _hoisted_27))
                        : (_ctx.currentNews.r)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 1,
                              to: _ctx.currentNews.r
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('news.' + _ctx.currentNews.t)), 1)
                              ]),
                              _: 1
                            }, 8, ["to"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t('news.' + _ctx.currentNews.t)), 1))
                    ], 64))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 32),
    (_ctx.uid && _ctx.showTutorial && !_ctx.allTasksCompleted && _ctx.users && _ctx.toList(_ctx.users).length > 0)
      ? (_openBlock(), _createBlock(_component_Tutorial, {
          key: 0,
          class: "no-print",
          onHideTutorial: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showTutorial = false)),
          someTaskCompleted: _ctx.checkAllTasks()
        }, null, 8, ["someTaskCompleted"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["ui sidebar vertical menu no-print", {'hidden': !_ctx.sidebarVisible}]),
      id: "side-menu"
    }, [
      _createVNode(_component_router_link, {
        class: "item",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_29,
          _createTextVNode(_toDisplayString(_ctx.$t('login.hp')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "item",
        to: "/about"
      }, {
        default: _withCtx(() => [
          _hoisted_30,
          _createTextVNode(_toDisplayString(_ctx.$t('login.ab')), 1)
        ]),
        _: 1
      }),
      (!_ctx.uid)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            class: "item",
            to: "/privacy-policy"
          }, {
            default: _withCtx(() => [
              _hoisted_31,
              _createTextVNode(_toDisplayString(_ctx.$t('login.pr')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, {
        class: "item",
        to: "/friends"
      }, {
        default: _withCtx(() => [
          _hoisted_32,
          _createTextVNode(_toDisplayString(_ctx.$t('login.fr')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "item",
        to: "/maps"
      }, {
        default: _withCtx(() => [
          _hoisted_33,
          _createTextVNode(_toDisplayString(_ctx.$t('login.mp')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "item",
        to: "/groups"
      }, {
        default: _withCtx(() => [
          _hoisted_34,
          _createTextVNode(_toDisplayString(_ctx.$t('login.gp')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "item",
        to: "/profile"
      }, {
        default: _withCtx(() => [
          _hoisted_35,
          _createTextVNode(_toDisplayString(_ctx.$t('login.fg')), 1)
        ]),
        _: 1
      }),
      (_ctx.uid)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            class: "item",
            to: "/book"
          }, {
            default: _withCtx(() => [
              _hoisted_36,
              _createTextVNode(_toDisplayString(_ctx.$t('login.bk')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, {
        class: "item",
        to: "/polis"
      }, {
        default: _withCtx(() => [
          _hoisted_37,
          _createTextVNode(_toDisplayString(_ctx.$t('login.polis')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "item",
        to: "/link"
      }, {
        default: _withCtx(() => [
          _hoisted_38,
          _createTextVNode(_toDisplayString(_ctx.$t('login.link')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "item",
        to: "/source_github"
      }, {
        default: _withCtx(() => [
          _hoisted_39,
          _createTextVNode(_toDisplayString(_ctx.$t('login.source_github')), 1)
        ]),
        _: 1
      }),
      (_ctx.uid)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            class: "item",
            to: "/privacy-policy"
          }, {
            default: _withCtx(() => [
              _hoisted_40,
              _createTextVNode(_toDisplayString(_ctx.$t('login.pr')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["ui sidebar bg no-print", {'hidden': !_ctx.sidebarVisible}]),
      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
    }, null, 2),
    _hoisted_41,
    (_ctx.doSearch(_ctx.$route.path))
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.mySearch) = $event)),
              placeholder: "關鍵字搜尋",
              autofocus: ""
            }, null, 512), [
              [_directive_autofocus, ],
              [_vModelText, _ctx.mySearch]
            ]),
            _createElementVNode("i", {
              class: "search icon",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.navTo('/friends')))
            })
          ])
        ], 512)), [
          [_vShow, _ctx.uid]
        ])
      : _createCommentVNode("", true),
    _hoisted_44,
    _createVNode(_component_router_view, {
      emailVerified: _ctx.emailVerified,
      isInApp: _ctx.isInApp,
      zoom: _ctx.zoom,
      uid: _ctx.uid,
      users: _ctx.users,
      book: _ctx.book,
      center: _ctx.center,
      places: _ctx.places,
      user: _ctx.user,
      mySearch: _ctx.mySearch,
      email: _ctx.email,
      photoURL: _ctx.photoURL,
      onLoginGoogle: _ctx.loginGoogle,
      onToggleLogin: _ctx.toggleLogin,
      onResendVerificationEmail: _ctx.resendVerificationEmail,
      onAddBook: _ctx.addBook,
      onRemoveBook: _ctx.removeBook,
      onLocate: _ctx.locate,
      onGetUserLocation: _ctx.getUserLocation,
      onLogout: _ctx.logout,
      onRegisterWithEmail: _ctx.registerWithEmail,
      onLoginWithEmail: _ctx.loginWithEmail
    }, null, 8, ["emailVerified", "isInApp", "zoom", "uid", "users", "book", "center", "places", "user", "mySearch", "email", "photoURL", "onLoginGoogle", "onToggleLogin", "onResendVerificationEmail", "onAddBook", "onRemoveBook", "onLocate", "onGetUserLocation", "onLogout", "onRegisterWithEmail", "onLoginWithEmail"]),
    _hoisted_45,
    _hoisted_46,
    _createVNode(_component_chatbox, {
      class: "no-print",
      id: "ch",
      onLoginGoogle: _ctx.loginGoogle,
      onToggleLogin: _ctx.toggleLogin,
      uid: _ctx.uid,
      user: _ctx.user,
      users: _ctx.users,
      photoURL: _ctx.photoURL
    }, null, 8, ["onLoginGoogle", "onToggleLogin", "uid", "user", "users", "photoURL"]),
    (_ctx.showLogin)
      ? (_openBlock(), _createBlock(_component_login, {
          key: 2,
          showLogin: _ctx.showLogin,
          isInApp: _ctx.isInApp,
          onLoginGoogle: _ctx.loginGoogle,
          onToggleLogin: _ctx.toggleLogin,
          onRegisterWithEmail: _ctx.registerWithEmail,
          onLoginWithEmail: _ctx.loginWithEmail
        }, null, 8, ["showLogin", "isInApp", "onLoginGoogle", "onToggleLogin", "onRegisterWithEmail", "onLoginWithEmail"]))
      : _createCommentVNode("", true)
  ], 64))
}